import { n as c } from "./Logger-CmiOOsKC.js";
import { C as l } from "./AssetTypes-DUDo9FdH.js";
import { ScreenshotTools as u } from "@babylonjs/core/Misc/screenshotTools.js";
var g = class i {
  static generateUniqueName(t, e) {
    if (!e.has(t)) return t;
    const r = t.match(/^(.+?)\s*\((\d+)\)$/), n = r ? r[1] : t;
    let o = 1, s = `${n} (${o})`;
    for (; e.has(s); )
      o++, s = `${n} (${o})`;
    return s;
  }
  static mimeTypeFromFilename(t) {
    return l(i.getFileExtensionFromSrc(t));
  }
  static getFileExtensionFromSrc(t) {
    if (!t) return "";
    const e = t.split(/[?#]/)[0], r = e.substring(e.lastIndexOf("/") + 1), n = r.lastIndexOf(".");
    return n > 0 ? r.substring(n + 1).toLowerCase() : "";
  }
  static parseLegacyJson(t) {
    try {
      return JSON.parse(t);
    } catch (e) {
      let r = "", n = !1;
      for (let o = 0; o < t.length; o++) {
        const s = t[o];
        if (n) {
          r += s, s === "\\" ? r += t[++o] ?? "" : s === '"' && (n = !1);
          continue;
        }
        if (s === '"') {
          n = !0, r += s;
          continue;
        }
        if (s === ",") {
          let a = o + 1;
          for (; a < t.length && /\s/.test(t[a]); ) a++;
          if (t[a] === "}" || t[a] === "]") continue;
        }
        r += s;
      }
      try {
        const o = JSON.parse(r);
        return c.warn("Legacy scene JSON has trailing commas; ignoring them"), o;
      } catch {
        throw e;
      }
    }
  }
  static parseInfoJson(t) {
    c.log("Parsing info.json");
    let e;
    try {
      e = i.parseLegacyJson(t);
    } catch (r) {
      return c.error("Failed to parse info.json:", r), null;
    }
    return !e.traces || e.traces.length === 0 ? (c.log("No traces found in info.json"), null) : {
      sceneInfo: { content: e.traces.map((r) => {
        const n = { ...r };
        if (r.preview) {
          n.src = r.preview.src;
          const { position: o, rotation: s, scale: a } = r.preview.pose;
          n.transform = {
            translation: o,
            rotation: s,
            scale: a
          };
        }
        return n;
      }) },
      sourceInfoFile: e
    };
  }
  static async captureScreenshot(t, e, r) {
    try {
      t.flushFramebuffer();
      const n = await u.CreateScreenshotAsync(t, e, { precision: 1 }, r);
      return c.log("Screenshot captured successfully!"), i.base64ToBlob(n, r);
    } catch (n) {
      throw c.error("Error during screenshot capture:", n), new Error("Failed to capture screenshot");
    }
  }
  static base64ToBlob(t, e = "") {
    const r = t.split(",")[1], n = atob(r), o = new Array(n.length);
    for (let a = 0; a < n.length; a++) o[a] = n.charCodeAt(a);
    const s = new Uint8Array(o);
    return new Blob([s], { type: e });
  }
  static async isBlobGLB(t) {
    if (!t.startsWith("blob:")) return !1;
    try {
      const e = (await fetch(t)).headers.get("Content-Type");
      return c.log("Blob content type:", e), e === "model/gltf-binary";
    } catch (e) {
      return c.error("Error checking blob content type:", e), !1;
    }
  }
};
export {
  g as t
};

//# sourceMappingURL=Utility-CviQuQTA.js.map